import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import { Component } from "react";
import { amchartCountryList } from "../../routes/intel/onboarding-screens/amchartCountries";
import { isoCountryCodes } from "../../routes/intel/onboarding-screens/isoCountryCodes";
am4core.addLicense("ch-custom-attribution");

class CategoryAxis extends Component {
  state = {
    chart: null,
    dateAxis: null,
    data: null,
  };
  componentDidMount() {
    const chart = am4core.create("categoryAxis" + this.props.id, am4charts.XYChart);
    chart.cursor = new am4charts.XYCursor(); //instantiate object of xy chart called chart
    chart.cursor.lineY.disabled = true; // added to remove y axis line on hover
    chart.cursor.lineX.disabled = true; // added to remove x axis line on hover
    chart.cursor.behavior = "none";
    this.createChart(chart); //create a chart from prev var
    this.setState(() => ({ chart })); // state save in local component
  }
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
  createChart = (chart) => {
    const suppress = !!this.props.suppressChartFilterInteractions;
    chart.data = this.props.linegraphData;
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = "key";
    categoryAxis.renderer.minGridDistance = 40;
    categoryAxis.fontSize = 10;
    categoryAxis.renderer.labels.template.dy = 5;
    // Below code is added for Making the Label as Capitalize on the X-Axis
    categoryAxis.renderer.labels.template.adapter.add("textOutput", function (text) {
      if (!!text && text !== "") {
        return text.toUpperCase();
      } else {
        return "";
      }
    });
    // end of the above code
    if (!!this.props && !!this.props.country && this.props.country === "usanalytics") {
      categoryAxis.renderer.labels.template.fontSize = 8;
      categoryAxis.renderer.labels.template.truncate = true;
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.grid.template.location = 10;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "left";
      categoryAxis.renderer.labels.template.rotation = 315;
      categoryAxis.tooltip.disabled = true;
      categoryAxis.renderer.minHeight = 110;
      categoryAxis.paddingBottom = -60;
    }
    let image = new am4core.Image();
    image.horizontalCenter = "middle";
    image.width = 20;
    image.height = 20;
    image.borderRadius = "50%";
    image.verticalCenter = "middle";
    image.cursorOverStyle = suppress ? am4core.MouseCursorStyle.default : am4core.MouseCursorStyle.pointer;
    image.adapter.add("href", (href, target) => {
      let category = target.dataItem.category ? target.dataItem.category.toUpperCase() : "";
      if (category && isoCountryCodes[category] && amchartCountryList[isoCountryCodes[category]]) {
        category = category.toLowerCase();
        return `https://www.amcharts.com/wp-content/uploads/flags/${category}.svg`;
      } else if (category && isoCountryCodes[category]) {
        return "http://purecatamphetamine.github.io/country-flag-icons/3x2/" + isoCountryCodes[category].toUpperCase() + ".svg";
      }
      return href;
    });
    categoryAxis.dataItems.template.bullet = image;
    categoryAxis.cursorTooltipEnabled = false; // added to remove category axis tooltip

    categoryAxis.renderer.labels.template.cursorOverStyle = suppress ? am4core.MouseCursorStyle.default : am4core.MouseCursorStyle.pointer;
    categoryAxis.renderer.labels.template.interactionsEnabled = !suppress;
    if (!suppress) {
      categoryAxis.renderer.labels.template.events.on(
        "hit",
        (ev) => {
          let item = ev.target.dataItem.dataContext.key;
          this.props.mapClickedFilterKey(!!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "", item);
        },
        this
      );
    }

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.minGridDistance = 30;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.cursorTooltipEnabled = false; // added to remove value axis tooltip
    if (!!this.props && !!this.props.country && this.props.country === "usanalytics") {
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.labels.template.fontSize = 10;
      valueAxis.title.text = this.props.mainLabel ? this.props.mainLabel : "";
      valueAxis.numberFormatter = new am4core.NumberFormatter();
      valueAxis.numberFormatter.smallNumberThreshold = 0.0001;
      valueAxis.numberFormatter.numberFormat = "#a"; //formats from 1e+9 into B instead of G
      valueAxis.numberFormatter.bigNumberPrefixes = [
        { number: 1e3, suffix: "K" },
        { number: 1e6, suffix: "M" },
        { number: 1e9, suffix: "B" },
        { number: 1e12, suffix: "T" },
      ];
    }

    let series = chart.series.push(new am4charts.ColumnSeries());

    series.dataFields.categoryX = "key";
    series.dataFields.valueY = !!this.props && !!this.props.country && this.props.country === "usanalytics" ? "value" : "sum_usd";
    series.adapter.add("tooltipHTML", () => {
      if (!!this.props && !!this.props.country && this.props.country === "usanalytics") {
        if (this.props.mainLabel === "Weight (kg)") {
          return `<span className="d-flex align-items-center horizontalLine" style="font-size: 12px;text-transform: uppercase;">{key}:<br/>{valueY.value}kg: <br/>{marketShare}%${suppress ? "" : ":<hr/> Click to Apply Filter"}</span>`;
        } else if (this.props.mainLabel.includes("%")) {
          return `<span className="d-flex align-items-center horizontalLine" style="font-size: 12px;text-transform: uppercase;">{key}:<br/>{valueY.value}${this.props.mainLabel}:${suppress ? "" : "<hr/> Click to Apply Filter"}</span>`;
        } else {
          return `<span className="d-flex align-items-center horizontalLine" style="font-size: 12px;text-transform: uppercase;">{key}:<br/>{valueY.value} ${this.props.mainLabel}:<br/>{marketShare}%${suppress ? "" : '<hr style="border-top: 1px solid white; margin: 7px 0";/> Click to Apply Filter'}</span>`;
        }
      } else if (this.props?.country?.toLowerCase() === "canada") {
        return `<span className="d-flex align-items-center horizontalLine" style="font-size: 12px;text-transform: uppercase;">USD {valueY.value}</span>`;
      } else {
        return `<span className="d-flex align-items-center horizontalLine" style="font-size: 12px;text-transform: uppercase;">USD {valueY.value}:<br/>${suppress ? "" : '<hr style="border-top: 1px solid white; margin: 7px 0";/> Click to Apply Filter'}</span>`;
      }
    });
    series.columns.template.tooltipY = 0;
    series.columns.template.strokeOpacity = 0;
    if (!!this.props && !!this.props.country && this.props.country === "usanalytics") {
      let hoverState = series.columns.template.states.create("hover");
      hoverState.properties.fill = am4core.color("#6f08f1");
      hoverState.properties.fillOpacity = 0.8;
      series.columns.template.adapter.add("fill", function () {
        return am4core.color("#D0D5DD");
      });
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#271c45");
      series.tooltip.background.strokeWidth = 0;
      series.columns.template.tooltipX = am4core.percent(100);
      series.columns.template.tooltipY = am4core.percent(0);
      series.numberFormatter = new am4core.NumberFormatter();
      series.numberFormatter.smallNumberThreshold = 0.0001;
      series.numberFormatter.numberFormat = "#.##a"; //formats from 1e+9 into B instead of G
      series.numberFormatter.bigNumberPrefixes = [
        { number: 1e3, suffix: "K" },
        { number: 1e6, suffix: "M" },
        { number: 1e9, suffix: "B" },
        { number: 1e12, suffix: "T" },
      ];
    }
    series.columns.template.cursorOverStyle = suppress ? am4core.MouseCursorStyle.default : am4core.MouseCursorStyle.pointer;
    series.columns.template.interactionsEnabled = !suppress;
    if (!suppress) {
      series.columns.template.events.on(
        "hit",
        (ev) => {
          let item = ev.target.dataItem.component.tooltipDataItem.dataContext;
          this.props.mapClickedFilterKey(!!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "", !!item && item.filterKey ? item.filterKey : item.key ? item.key : "");
        },
        this
      );
    }
  };
  render() {
    return (
      <div className="lineChart w-100 h-100">
        {!!this.props && !!this.props.country && this.props.country === "usanalytics" ? <div id={"categoryAxis" + this.props.id} style={{ width: "100%", height: "280px" }} /> : <div id={"categoryAxis" + this.props.id} style={{ width: "100%", height: "335px" }} />}
        {/* {this.state.chart ?
              <AmchartsReact
                chart={this.state.chart}
              />
              : null} */}
      </div>
    );
  }
}
export default CategoryAxis;
